import {Component, EventEmitter, Output} from '@angular/core';
import {Router} from "@angular/router";
import {ApiServiceService} from "../../../../../Services/api-service.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FormService} from "../form.service";
/**
 * @author Olive
 * email: oogbujie@oasismgt.net
 * 25 May, 2024
 **/
@Component({
  selector: 'app-corporate-information',
  templateUrl: './corporate-information.component.html',
  styleUrls: ['./corporate-information.component.css']
})
export class CorporateInformationComponent {
  basicForm: FormGroup;
  nbList = []

  constructor(
      private apiServer:ApiServiceService,
      private formService:FormService) {
  }
  state:any;
  state2:any;
  lga:any;
  area:any;

  screenHeight = window.screen.height - 271; // 1058
  minHeight = 'min-height: ' + this.screenHeight + 'px !important'

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = 'min-height: ' + this.screenHeight2 + 'px !important'

  natureOfBusiness() {
    this.apiServer.LoginGet('/auth/nature_of_business/all', {}).subscribe(res => {
      console.log(res)
      this.nbList = res
    })
  }
  getState2(){
    this.apiServer.LoginGet('/auth/state/all', {}).subscribe(res => {
      this.state2 = res
    })
  }
  getState(){
    this.apiServer.LoginGet('/auth/state/all', {}).subscribe(res => {
      this.state = res
    })
  }
  public getLga() {
    console.log(this.basicForm.value.businessState)
    this.apiServer.LoginGet(`/auth/lga/state/all/${this.formService.businessInformationGroup.get("businessState").value.split('-')[0]}`, {}).subscribe(res => {
      this.lga = res
    })
  }
  public getArea() {
    this.apiServer.LoginGet(`/auth/area/all/${this.formService.businessInformationGroup.get("businessLga").value.split('-')[0]}`, {}).subscribe(res => {
      this.area = res
    })
  }

  ngOnInit() {
    this.natureOfBusiness()

    this.basicForm = this.formService.getForm();
    this.getState();
    this.getState2();
  }

  onSubmit() {
    this.nextStep();
  }

  nextStep() {
    this.formService.sendMessage(3);
  }

  cancel() {
    this.formService.sendMessage(0)
  }
}
